var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from 'mobx';
import { MobxPrepone } from '../../../utils/mobx/decorators/MobxPrepone';
import { sortedSet } from '../../../utils/mobx/decorators/customComputed';
export class AspectContentLocal {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspectContent() {
        return this.parent;
    }
    get aspect() {
        return this.parent.aspect;
    }
    /*
    get ensuredTraitOfKey(key): Trait<'text'> {
      if (this.aspect.local.has.text) {
        return this.aspect.local.traitOf.text as Trait<'text'>;
      }
      return this.addedTraitOfKey('text');
    }
  */
    addedTraitOfKey(key) {
        return MobxPrepone.provideInstant({
            owner: this,
            instantFactory: () => this.aspect.aspectCreateTrait.provideTraitByKey(key),
            modifyState: trait => this.aspect.aspectCreateTrait.addTraitToEnd(trait),
            context: key,
        });
    }
    get contentTraits() {
        return [
            ...this.aspect.local.traitsOf.image,
            ...this.aspect.local.traitsOf.text,
            ...this.aspect.local.traitsOf.childFromSkeleton,
            //   ...this.aspect.local.traitsOf.childFromTraverse,
            ...this.aspect.local.traitsOf.childFromAspectName,
        ];
    }
    get hasContent() {
        return this.contentTraits.length > 0;
    }
    get isEmpty() {
        return !this.hasContent;
    }
    get primaryTextBasis() {
        if (!this.aspect.local.has.text) {
            return '';
        }
        return this.aspect.local.ensuredTraitOf.text.local.valueOf.textBasis;
    }
    set primaryTextBasis(s) {
        this.aspect.local.ensuredTraitOf.text.local.valueOf.textBasis = s;
    }
}
__decorate([
    sortedSet
], AspectContentLocal.prototype, "contentTraits", null);
